import { getServiceLabel } from '@common/customControls/getServiceLabel';
import { getDisplayName } from '@common/utils/getDisplayName';
import { FormGroupRead } from '@frontend/components/pages/customControls/utils/v1/FormGroupRead';
import type { ICustomControlRequestReadProps } from '../../interfaces';
import { RequestReadButtons } from '../../../../elements/carePathButtons/RequestReadButtons';
import { ProcessContainer } from '../../../episodes/common';
import { ProcessItemHeader } from '../../../episodes/ProcessItemHeader';
import { CustomControlCollapseBody } from '../../utils/v1/CustomControlCollapseBody';
import { ProfileImages } from '../../utils/v1/ProfileImages';

export function OcrkV1RequestRead(props: ICustomControlRequestReadProps) {
    return (
        <ProcessContainer isActiveActivity={props.itemState.initialIsOpen}>
            <ProcessItemHeader
                date={props.request.dateSent}
                isFirstItem={props.isFirstItem}
                isFirstProcess={props.itemState.isFirstProcess}
                isItemOpen={props.itemState.isOpen}
                onToggle={(isOpened) => props.updateItemState({ ...props.itemState, isOpen: isOpened })}
                organizationName={props.process.requesterOrganization?.name}
                practitionerName={
                    props.process.requesterPractitioner
                        ? getDisplayName(props.process.requesterPractitioner)
                        : undefined
                }
                process={props.process}
                serviceType={props.process.serviceType}
                title={getServiceLabel(props.process.code, 'request', props.process.name)}
            />

            <CustomControlCollapseBody isOpen={props.itemState.isOpen}>
                <ProfileImages request={props.request} />
                <FormGroupRead
                    label="Vraag"
                    value={props.request.question}
                />
                <FormGroupRead
                    label="Toelichting"
                    value={props.request.customControlData.toelichting}
                />
            </CustomControlCollapseBody>

            <RequestReadButtons
                {...props}
                removeProcess={async () => {
                    await props.removeProcess();
                    if (props.request.previousRequestId) {
                        await props.removeProcess(props.request.previousRequestId);
                    }
                }}
            />
        </ProcessContainer>
    );
}
